









import { defineComponent, onBeforeMount, onBeforeUnmount, ref } from "@vue/composition-api";
import { Transaction } from "@scrile/api-provider/dist/api/TransactionProvider";
import useAuthUser from "@/hooks/useAuthUser";
import useBalance from "@/hooks/useBalance";
import usePager from "@/hooks/usePager";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";
import BalanceView from "./components/BalanceView.vue";

export default defineComponent({
  name: "PageBalance",
  components: { BalanceView },
  setup() {
    const { getBalance, balance } = useBalance();
    const { authUserStrict } = useAuthUser();
    const loading = ref(false);

    const { items: transactionsList, getFirstPage: getTransactions, getNextPage, enableScroll, addItem } = usePager(
      page => {
        return providers.TransactionProvider.find({
          data: { userId: authUserStrict.value.id, page, sort: "TIME,DESC" },
        });
      }
    );

    const handlePurchase = (transaction?: Transaction) => {
      if (!transactionsList.value || !transaction) {
        return;
      }
      addItem(transaction);
    };

    onBeforeMount(async () => {
      emitter.on<Transaction>(EVENTS.BALANCE_REFILL_PURCHASED, handlePurchase);
      try {
        loading.value = true;
        await Promise.all([getTransactions(), getBalance()]);
      } finally {
        loading.value = false;
      }
    });

    onBeforeUnmount(() => {
      emitter.off<Transaction>(EVENTS.BALANCE_REFILL_PURCHASED, handlePurchase);
    });

    return { loading, balance, enableScroll, transactionsList, getNextPage };
  },
});
